import React, { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import styled from 'styled-components'
import ShareIcon from '@8x8/oxygen-icon/novo/ShareIcon'
import { IconButton } from '@8x8/oxygen-icon-button'

import { copyShareableLinkToClipboard } from '~/actions/recents'
import { translate } from '~/core/translate'
import { getIsMobileSummaryPage, isMeetingAssetsPage, isSalesforceIntegration } from '~/selectors/app'

const StyledShareIcon = styled(ShareIcon)`
  size: 24px;
  color: ${({ theme }) => theme._neo.icon01};
`

const SlideshowActions = ({ recording }) => {
  const dispatch = useDispatch()
  const isMobileSummary = useSelector(getIsMobileSummaryPage)
  const isSalesforceSummary = useSelector(isSalesforceIntegration)
  const isMeetingAssetsUrl = useSelector(isMeetingAssetsPage)

  const canShare = !isMobileSummary && !isSalesforceSummary && !isMeetingAssetsUrl && !recording.isHighlight

  const share = useCallback(e => {
    e.stopPropagation?.()

    dispatch(copyShareableLinkToClipboard(recording))
  }, [dispatch, recording])

  return (
    <>
      {canShare && (
        <IconButton
          data-test-id='recording-share-button'
          onClick={share}
          aria-label={translate('tooltip_share_recording')}
        >
          <StyledShareIcon />
        </IconButton>
      )}
    </>
  )
}

export default SlideshowActions
